export function gridCellFlash(gridApi, event) {

  if( !event.colDef || !event.node )
    return;

  const { colDef } = event;
  const { rowIndex } = event.node;
  const colId = colDef.field || 'id';

  // Query AG Grid's DOM for the exact cell
  const cellSelector = `.ag-center-cols-container .ag-row[row-index="${rowIndex}"] .ag-cell[col-id="${colId}"]`;
  const cell = document.querySelector(cellSelector);

  if (!cell) {
    console.warn("Flash cell not found:", cellSelector);
    return;
  }

  // Restart animation
  cell.classList.remove("cell-flash");
  void cell.offsetWidth; // force reflow
  cell.classList.add("cell-flash");
}
